import { render } from "./QueenRound.vue?vue&type=template&id=7214d784&scoped=true"
import script from "./QueenRound.vue?vue&type=script&lang=js"
export * from "./QueenRound.vue?vue&type=script&lang=js"

import "./QueenRound.vue?vue&type=style&index=0&id=7214d784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7214d784"]])

export default __exports__